import React from 'react';
import Dropdown from 'react-dropdown';

class FabeSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsOpen: false
        }

        this.wrapperRef = React.createRef();
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
    }

    toggleOptions() {
        if (!this.props.preventClick) {
            this.setState(prevState => ({
                optionsOpen: !prevState.optionsOpen
            }));
        }
    }


    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    handleClickOutside(event) {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ optionsOpen: false });
        }
    }

    handleOptionClick(value) {
        this.toggleOptions();
        this.props.changeHandler(value);
    }

    render() {
        let options = this.props.options.map((option, index) => {
            const [name, value, prefix] = typeof option === 'string' ? [option, option, null] : [option.name, option.value, option.prefix || null];
            return <button key={index} value={value} onClick={() => this.handleOptionClick(value)}>{prefix}{name}</button>;
        });

        return (
            <div className={"fabe-input flex flex-wrap " + this.props.classes} ref={this.wrapperRef}>
                { this.props.icon }
                {this.props.label && <label className="fabe-input__label">{this.props.label}</label>}
                <div className="fabe-input__select-toggle" onClick={this.toggleOptions}>{this.props.placeholder}</div>
                <div className={"fabe-input__options-list " + (this.state.optionsOpen ? "expanded" : "")}>
                    { this.state.optionsOpen ? options : ""}
                </div>
            </div>
        )
    }
}

export default FabeSelect;



// WEBPACK FOOTER //
// ./scripts/components/FabeSelect.jsx